import { useEffect } from "react";
import "./TermsConditionsStyle.css"; // Reusing the same styles

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page-container">
      <h1 className="legal-heading">Privacy Policy</h1>
      <div className="legal-content">
        <div className="legal-section">
          <h2>1. Information We Collect</h2>
          <p>
            We collect information you provide directly to us, such as when you create an account, 
            make a purchase, or contact us for support. This includes:
          </p>
          <ul>
            <li>Personal information (name, email address, phone number)</li>
            <li>Billing and shipping addresses</li>
            <li>Payment information (processed securely through Stripe and Razorpay)</li>
            <li>Order history and preferences</li>
            <li>Communications with our customer service team</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>2. Automatically Collected Information</h2>
          <p>
            When you visit our website, we automatically collect certain information about your device, 
            including:
          </p>
          <ul>
            <li>IP address and geolocation data</li>
            <li>Browser type and version</li>
            <li>Device information and operating system</li>
            <li>Pages visited and time spent on our site</li>
            <li>Referral sources and search terms</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>3. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Process and fulfill your orders</li>
            <li>Communicate with you about your orders and account</li>
            <li>Provide customer support</li>
            <li>Improve our website and services</li>
            <li>Send promotional emails (with your consent)</li>
            <li>Prevent fraud and enhance security</li>
            <li>Comply with legal obligations</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>4. Information Sharing and Disclosure</h2>
          <p>We may share your information with:</p>
          <ul>
            <li><strong>Payment Processors:</strong> Stripe and Razorpay to process payments securely</li>
            <li><strong>Shipping Partners:</strong> To deliver your orders</li>
            <li><strong>Service Providers:</strong> Third-party companies that help us operate our business</li>
            <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
          </ul>
          <div className="policy-highlight">
            <p>We never sell your personal information to third parties for marketing purposes.</p>
          </div>
        </div>

        <div className="legal-section">
          <h2>5. Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information against 
            unauthorized access, alteration, disclosure, or destruction. This includes:
          </p>
          <ul>
            <li>SSL encryption for data transmission</li>
            <li>Secure payment processing through certified providers</li>
            <li>Regular security assessments and updates</li>
            <li>Limited access to personal information on a need-to-know basis</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>6. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, 
            and understand customer preferences. You can manage cookie preferences through your browser settings.
          </p>
        </div>

        <div className="legal-section">
          <h2>7. International Data Transfers</h2>
          <p>
            As we serve customers in North America, Europe, and Australia from our base in India, 
            your information may be transferred to and processed in countries other than your own. 
            We ensure appropriate safeguards are in place for such transfers.
          </p>
        </div>

        <div className="legal-section">
          <h2>8. Your Rights and Choices</h2>
          <p>Depending on your location, you may have the following rights:</p>
          <ul>
            <li>Access to your personal information</li>
            <li>Correction of inaccurate information</li>
            <li>Deletion of your personal information</li>
            <li>Restriction of processing</li>
            <li>Data portability</li>
            <li>Opt-out of marketing communications</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>9. Data Retention</h2>
          <p>
            We retain your personal information for as long as necessary to fulfill the purposes outlined 
            in this policy, comply with legal obligations, resolve disputes, and enforce our agreements. 
            Account information is typically retained for 7 years after account closure.
          </p>
        </div>

        <div className="legal-section">
          <h2>10. Children's Privacy</h2>
          <p>
            Our services are not intended for individuals under the age of 13. We do not knowingly 
            collect personal information from children under 13. If we become aware that we have 
            collected such information, we will take steps to delete it.
          </p>
        </div>

        <div className="legal-section">
          <h2>11. Updates to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any material 
            changes by posting the new policy on this page with an updated effective date. We encourage 
            you to review this policy periodically.
          </p>
        </div>

        <div className="legal-section">
          <h2>12. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or our data practices, please contact us at:
          </p>
          <p>
            Email: privacy@minute.com<br/>
            Address: Minute Privacy Department, India<br/>
            Phone: +91-XXX-XXX-XXXX
          </p>
        </div>

        <div className="legal-footer">
          <p><strong>Last Updated:</strong> January 2025</p>
        </div>
      </div>
    </div>
  );
};

export { PrivacyPolicy };